import { GetSessionV2Response } from "@endavaaccorplus/payments-common/schemas";

// IMPORTANT: If pwp is enabled for any other type - this function needs to be updated.
// This attribute has to confirm attribute based on sessionType as paymentAmount only exists on pwp enabled session types.
export const getPwpPaidAttributes = (session: GetSessionV2Response) => {
  switch (session.type) {
    case "renew-public":
    case "register-public":
      const { points = 0, price } = session.paymentAmount;

      if (points > 0) {
        if (points === session.purchaseAmount.points && price === "0") {
          return "Yes - Full";
        }
        return "Yes - Partial";
      }
      return "No";
    default:
      return "No";
  }
};
